import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';

import { CustomerDTO, IS_NOT_EMPTY, RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { Cargochief } from '@service/cargochief/cargochief.service';

import { debounceTime, finalize, switchMap, tap } from 'rxjs/operators';

@Component({
	selector: 'app-customer-selector',
	templateUrl: './customer-selector.component.html',
	styleUrls: ['./customer-selector.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CustomerSelectorComponent implements OnInit {
	@Output() setCustomer = new EventEmitter<any>();
	@Input() customerSelected: CustomerDTO = null;
	@Input() placeholder: string = 'Customer Name';
	@Input() floatLabel: string = 'always';
	@Input() appearance: string = 'legacy';
	@Input() customCssClass: string = '';
	@Input() useChips: boolean = false;
	@Input() updateCustomerOnEnter: boolean = false;
	@Input() showInputWithIcon: boolean = false;

	separatorKeysCodes: number[] = [ENTER];
	addOnBlur = false;
	isLoading: boolean = false;

	customersList: Array<CustomerDTO> = null;
	customerCtrl = new UntypedFormControl();

	customerNames: string[];
	accountId: number = null;
	isCustomerSearchEnabled = true;

	@ViewChild('customerInput') customerInput: ElementRef<HTMLInputElement>;
	@ViewChild('auto') matAutocomplete: MatAutocomplete;

	constructor(
		public utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService,
		private cargochief: Cargochief
	) {}

	ngOnInit() {
		if (!this.utilService.isNullOrUndefined(this.customerSelected)) {
			this.isCustomerSearchEnabled = false;
		}
		if (!this.useChips) {
			this.customerCtrl.setValue(this.customerSelected);
		}
		this.accountId = this.cargochief.ACCOUNT_ID;
		this.customerCtrl.valueChanges
			.pipe(
				debounceTime(300),
				tap(() => {
					this.isLoading = true;
				}),
				switchMap((value) => {
					if (
						!this.useChips &&
						!this.updateCustomerOnEnter &&
						!this.utilService.isNullOrUndefined(value) &&
						this.utilService.isNullOrUndefined(value.name)
					) {
						this.customerSelected = null;
						if (IS_NOT_EMPTY(value)) {
							this.customerSelected = this.addNewCustomer(value);
						}
						this.setCustomer.emit(this.customerSelected);
					}
					const url = this.urlService.getCustomers(0, 25, value, this.accountId);
					return this.restService.GET(url).pipe(
						finalize(() => {
							this.isLoading = false;
						})
					);
				})
			)
			.subscribe((customers) => {
				this.customersList = customers.data['content'].sort(
					(a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1)
				);
				this.customerNames = [];
				this.customersList.map((customer) => {
					this.customerNames.push(customer.name);
				});
			});
	}

	add(event: MatChipInputEvent) {
		const input = event.input;
		const value = event.value;
		if ((value || '').trim()) {
			this.customerSelected = this.addNewCustomer(value);
			this.isCustomerSearchEnabled = false;
			this.setCustomer.emit(this.customerSelected);
		}
		if (input) {
			input.value = '';
		}
	}

	addNewCustomer(name: string): CustomerDTO {
		let customer = {} as CustomerDTO;
		customer.name = name;
		return customer;
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		if (this.useChips) {
			let customerId = null;
			if (
				!this.utilService.isNullOrUndefined(event.option) &&
				!this.utilService.isNullOrUndefined(event.option.value)
			) {
				customerId = event.option.value;
			}
			if (!this.utilService.isNullOrUndefined(customerId) && IS_NOT_EMPTY(customerId)) {
				this.customerSelected = this.customersList.filter(
					(customer) => (customer.id = customerId)
				)[0];
				this.isCustomerSearchEnabled = false;
				this.setCustomer.emit(this.customerSelected);
			}
		} else if (
			!this.utilService.isNullOrUndefined(this.customerCtrl.value) &&
			!this.utilService.isNullOrUndefined(event.option)
		) {
			this.setCustomer.emit(this.customerCtrl.value);
		}
	}

	enableSearch() {
		this.isCustomerSearchEnabled = true;
		this.customerSelected = null;
		this.setCustomer.emit(this.customerSelected);
	}

	displayFn(customer: CustomerDTO) {
		return customer && customer.name ? customer.name : '';
	}

	addAndSetNewCustomer() {
		if (
			!this.utilService.isNullOrUndefined(this.customerCtrl.value) &&
			IS_NOT_EMPTY(this.customerCtrl.value)
		) {
			this.customerSelected = this.addNewCustomer(this.customerCtrl.value);
			this.isCustomerSearchEnabled = false;
			this.setCustomer.emit(this.customerSelected);
		}
	}

	initializeList() {
		if (this.utilService.isNullOrUndefined(this.customerCtrl.value)) {
			this.customerCtrl.setValue('');
		} else if (
			!this.utilService.isNullOrUndefined(this.customerCtrl.value) &&
			!this.utilService.isNullOrUndefined(this.customerCtrl.value.id) &&
			IS_NOT_EMPTY(this.customerCtrl.value.name)
		) {
			if (this.utilService.isNullOrUndefined(this.customersList)) {
				this.customersList = [];
			}
			this.customersList.push(this.customerCtrl.value);
		}
	}
}
